// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner--6vdf7","small":"small--6vdf7","centred":"centred--6vdf7"};